import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef, useCallback, useState, useEffect } from 'react';
import { getMenuData } from '../../utils/menuHelper.js';
import { getActiveRuleSetFromUrl } from '../../utils/UrlUtil.js';
import { noop, noopHook } from '../../utils/noop.js';
import { SidebarMenu } from './sidebar-menu/component.js';

var Sidebar = function Sidebar(_ref) {
  var currentUrl = _ref.currentUrl,
      organization = _ref.organization,
      user = _ref.user,
      environment = _ref.environment,
      slug = _ref.slug,
      _ref$useNavigate = _ref.useNavigate,
      useNavigate = _ref$useNavigate === void 0 ? noop : _ref$useNavigate,
      _ref$useSearchParams = _ref.useSearchParams,
      useSearchParams = _ref$useSearchParams === void 0 ? noopHook : _ref$useSearchParams,
      options = _ref.options,
      onChange = _ref.onChange;
  var currentRuleSetName = useRef(null);
  var navigate = useNavigate();

  var _useSearchParams = useSearchParams(),
      _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
      searchParams = _useSearchParams2[0];

  if (searchParams) {
    currentRuleSetName.current = searchParams.get('current_rule_set_name');
  }

  var buildMenuData = useCallback(function () {
    if (!user) return null;
    var isAdmin = !organization;

    if (!currentRuleSetName.current && !isAdmin) {
      currentRuleSetName.current = getActiveRuleSetFromUrl(user.rule_sets, currentUrl).name;
    }

    return getMenuData({
      slug: slug,
      environment: environment,
      user: user,
      organization: organization,
      currentRuleSetName: currentRuleSetName.current,
      isAdmin: isAdmin,
      currentUrl: currentUrl
    });
  }, [currentUrl, environment, organization, slug, user]);

  var _useState = useState(buildMenuData()),
      _useState2 = _slicedToArray(_useState, 2),
      menuData = _useState2[0],
      setMenuData = _useState2[1];

  useEffect(function () {
    if (user && slug) {
      setMenuData(buildMenuData());
    }
  }, [setMenuData, slug, user, buildMenuData]);

  if (menuData) {
    return /*#__PURE__*/React.createElement(SidebarMenu, {
      currentRuleSets: user ? user.rule_sets : [],
      currentUrl: currentUrl || window.location.href,
      frontEndDomain: environment.MENU_DOMAIN_FOR_FRONT_END,
      menuData: menuData,
      navigate: navigate,
      options: options,
      onChange: onChange
    });
  } else {
    return /*#__PURE__*/React.createElement("nav", {
      id: "sidebar",
      "data-component-type": "sidebar",
      className: "nav sidebar"
    });
  }
};

Sidebar.displayName = 'Sidebar';
export { Sidebar };